module.exports = __webpack_public_path__ + "img/313300476.8e81eb08.jpg";